import { tv } from "../../variants/tv.js";
const mediaSnippetVariants = tv({
    slots: {
        rootSlot: '@container flex w-full flex-col text-left',
        mediaWrapperSlot: 'relative mb-3 w-full overflow-hidden rounded-xl transition-shadow group-hover:shadow-xl',
        mediaImageSlot: 'fill-mode-forwards absolute inset-0 h-full w-full',
        scrimSlot: 'pointer-events-none absolute inset-x-0 bottom-0',
        headingSlot: 'mb-1 text-heading6 text-primary-13 @md:text-heading4',
        bodySlot: 'text-primary-13'
    }
});
export { mediaSnippetVariants };
